export default __webpack_public_path__ + "static/media/FullText.3c0154a3.svg";